export const home = {
  SUPPLIER_INTRO_TITLE: 'Seja fornecedor\nno Sebraeplace!',
  SUPPLIER_INTRO_P1:
    'Sua empresa faz consultoria, realiza capacitações ou tem uma solução fantástica para outras empresas?',
  SUPPLIER_INTRO_P2:
    'Conheça todas as modalidades disponíveis, faça seu cadastro e participe da maior vitrine de soluções para negócios do Brasil.',
  SUPPLIER_PREV: 'Anterior',
  SUPPLIER_NEXT: 'Próximo',
  PROFESSIONALS_PREV: 'Anterior',
  PROFESSIONALS_NEXT: 'Próximo',
  FEATURE_QUALITY_TITLE: 'Garantia de qualidade',
  FEATURE_QUALITY_BODY_1:
    'Todas as soluções foram selecionadas e homologadas pelo ',
  FEATURE_QUALITY_BODY_2:
    ', que também já negociou as melhores condições para você.',
  FEATURE_SECURITY_TITLE: 'Segurança, do início ao fim',
  FEATURE_SECURITY_BODY_1: 'Você pode acionar o ',
  FEATURE_SECURITY_BODY_2:
    ' a qualquer momento para ter a garantia de segurança do serviço prestado.',
  FEATURE_PAYMENT_TITLE: 'Pague como preferir',
  FEATURE_PAYMENT_BODY_1:
    'Realize o pagamento sempre pelo Sebraeplace com boleto ou cartão de crédito à vista ou em até 6x.',
  FEATURE_PAYMENT_BODY_2: ' *Consulte as condições',
  KNOW_MORE: 'Saiba mais',
  SUPPLIER_KNOW_MORE: 'Conheça mais',
  HOW_IT_WORKS_TITLE: 'Saiba como funciona o Sebraeplace',
  HOW_IT_WORKS_BODY_1:
    'É muito simples! Escolha o tipo de serviço que deseja, navegue entre as opções apresentadas, analise, converse, compare e contrate.',
  HOW_IT_WORKS_BODY_2:
    'Se tiver alguma dúvida, nossa equipe está sempre à postos, é só clicar no ícone de atendimento ali embaixo.',
  USE_TERMS: 'Termos de uso',
  HOW_REGISTER_TITLE: 'Cadastre-se agora no ',
  YOU_ARE_SUPPLIER: 'Você é um fornecedor',
  YOU_ARE_CLIENT: 'Você é um cliente',
  CREATE_ACCOUNT: 'Crie sua conta',
  GO_TO_ACCOUNT: 'Acessar minha conta',
  SUGGESTIONS_PREV: 'Anterior',
  SUGGESTIONS_NEXT: 'Próximo',
  FAVORITE_ARIA: 'Favoritar',
  TAG_SEBRAETEC: 'Sebraetec',
  TAG_CONSULTORIA: 'Consultoria',
  TAG_CURSO: 'Curso online',
  TAG_SOLUCAO: 'Solução inteligente',
  HERO_TITLE_PREFIX: 'Sebraeplace, o',
  HERO_TITLE_HIGHLIGHT: 'marketplace',
  HERO_TITLE_SUFFIX: 'de soluções para o seu negócio',
  HERO_SUBTITLE:
    'As melhores soluções, o melhor preço.\nContrate de forma fácil e segura com a curadoria do Sebrae.',
  HERO_IMAGE_ALT: '',
  CATEGORY_SEBRAETEC_LABEL: 'Quero Sebraetec',
  CATEGORY_SEBRAETEC_SUB:
    'Leve tecnologia e competitividade para sua empresa com soluções sob medida.',
  CATEGORY_CONSULTORIA_LABEL: 'Quero Consultoria',
  CATEGORY_CONSULTORIA_SUB:
    'Conte com especialistas para orientar decisões e acelerar o crescimento do seu negócio.',
  CATEGORY_SOLUCOES_LABEL: 'Quero Soluções inteligentes',
  CATEGORY_SOLUCOES_SUB:
    'Inove, otimize e cresça com soluções inteligentes personalizadas para as necessidades do seu negócio.',
  CATEGORY_CURSO_LABEL: 'Quero Curso online',
  CATEGORY_CURSO_SUB:
    'Aprenda no seu ritmo e desenvolva habilidades que fazem seu negócio crescer.',
  CATEGORY_SEARCH: 'Buscar',
  CATEGORY_SOON: 'Em breve'
};
